import gql from 'graphql-tag';
import { addressFieldsFragment } from './addressFieldsFragment';
import { sanityDocumentFieldsFragment } from './sanityDocumentFieldsFragment';

export const companyFieldsFragment = gql`
  fragment AdminCompanyFields on Company {
    ... on SanityDocument {
      ...AdminSanityDocumentFields
    }
    name
    address {
      ...AdminAddressFields
    }
    archived
  }

  ${sanityDocumentFieldsFragment}
  ${addressFieldsFragment}
`;
